/**
 * @param {number | String} id
 * @return {boolean}
 */
export const isSeries = (id) => id === 'series'

/**
 * @param {Array<any>} arr
 * @param {String} name Base name for the copied entity
 * @param {String} attribute The name of the attribute which names each entity
 * @return {String}
 */
export const getCopyName = (arr, name, attribute, counter = 0) => {
  let copyName = counter ? `${name} ${counter}` : name
  const hasDuplicate = arr.some((item) => {
    return item[attribute] && item[attribute].indexOf(copyName) !== -1
  })
  if (hasDuplicate) {
    return getCopyName(arr, name, attribute, counter + 1)
  }
  return copyName
}
